import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import styles from './WalletModal.module.scss';
const SharedWalletModal = ({ activeElem, address, WalletItems, Privacy, connectText }) => {
    return (_jsx(_Fragment, { children: activeElem === 'wallet' && (_jsxs("div", Object.assign({ className: 'd-flex justify-content-between flex-column' }, { children: [_jsx("div", { children: _jsx("div", Object.assign({ className: styles.walletAddressContainer + ' d-flex align-items-center' }, { children: address })) }), _jsx("div", { children: WalletItems }), _jsx("div", { children: Privacy })] }))) }));
};
export default SharedWalletModal;
